// Shown only while the in-page CTA is off screen, so attendees never have to hunt for the button.
// Stays under the disclaimer dialog's z-50.
import { type Component } from "solid-js"
import { type OfferingProps } from "../shared/offering-props"
import WebinarPurchaseButton from "./WebinarPurchaseButton"

const WebinarStickyCta: Component<OfferingProps> = (props) => {
  const currencyFormatter = (value?: number): string => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(value!)
  }

  return (
    <div class='fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0D171C]/95 backdrop-blur-sm shadow-[0_-8px_24px_rgba(0,0,0,0.35)] px-4 sm:px-10 lg:px-20 py-3'>
      <div class='max-w-[800px] mx-auto flex items-center justify-between gap-4'>
        <div class='hidden sm:flex flex-col text-start'>
          <span class='text-lg leading-6 font-bold font-poppins text-white'>
            Today's Price:{" "}
            <span class='text-forest_green-500'>{currencyFormatter(props.offeringPrice)}</span>
          </span>
          <span class='text-xs leading-4 text-gray-300'>
            Renews at $359.88 after one year. Cancel anytime.
          </span>
        </div>
        <div class='w-full sm:w-[320px]'>
          <WebinarPurchaseButton showCheckout={props.showCheckout} fullWidth={true} />
        </div>
      </div>
    </div>
  )
}

export default WebinarStickyCta
